// Naming format: [component]_[description]_[element-type]
const STEP_LICENSE_PLATE_LPN_INPUT = 'step-license-plate-lpn-input'
const STEP_LICENSE_PLATE_SEARCH_BUTTON = 'step-license-plate-search-button'
const STEP_LICENSE_PLATE_NO_INVOICES_INFORMATION =
  'step-license-plate-no-invoices-information'
const STEP_INVOICE_INVOICE_CONTAINER = 'step-invoice-invoice-container'

export default {
  STEP_LICENSE_PLATE_LPN_INPUT,
  STEP_LICENSE_PLATE_SEARCH_BUTTON,
  STEP_LICENSE_PLATE_NO_INVOICES_INFORMATION,
  STEP_INVOICE_INVOICE_CONTAINER,
}
